import { render } from "./SubTitle3.vue?vue&type=template&id=7666570b&scoped=true"
import script from "./SubTitle3.vue?vue&type=script&lang=js"
export * from "./SubTitle3.vue?vue&type=script&lang=js"

import "./SubTitle3.vue?vue&type=style&index=0&id=7666570b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7666570b"]])

export default __exports__